import "../../../styles/components/browse/Sidebar.css";
import "../../../styles/components/browse/History.css";
import { Button } from "@mui/material";
import SidebarSkeleton from "../../skeleton/SidebarSkeleton";

const Sidebar = ({ container, setContainer, isLoading, histories }) => {
    return (
        <div className="browse-sidebar">
            <div className="switch-container">
            <div className="scrollable-btn-group">
  <Button className={container === "Chat" ? "active" : ""} onClick={() => setContainer("Chat")}>Chat</Button>
  <Button className={container === "Browse" ? "active" : ""} onClick={() => setContainer("Browse")}>Search</Button>
  <Button className={container === "ScratchPad" ? "active" : ""} onClick={() => setContainer("ScratchPad")}>Scratch</Button>
  <Button className={container === "ReverseSearch" ? "active" : ""} onClick={() => setContainer("ReverseSearch")}>Reverse Search</Button>
  <Button className={container === "Agent" ? "active" : ""} onClick={() => setContainer("Agent")}>Agent</Button>
</div>
            </div>
            {/* <div className="browse-history-container">
                {isLoading ? <SidebarSkeleton /> : histories}
            </div> */}
        </div>
    );
}

export default Sidebar